import { useState } from "react";

export const useOpportunityAlert = ({
  onDismiss,
  resetForm,
  opportunityId,
  setShowShare,
  setOpportunityId
}) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const onAlertCancel = () => setIsAlertOpen(false);

  const onAlertConfirm = () => {
    resetForm();
    setIsAlertOpen(false);
    onDismiss();
  };

  const onDismissSidebar = () => {
    if (!!opportunityId) {
      resetForm();
      setShowShare(false);
      setOpportunityId("");
      onDismiss();
    } else {
      setIsAlertOpen(true);
    }
  };

  return {
    isAlertOpen,
    onAlertCancel,
    onAlertConfirm,
    onDismissSidebar
  };
};
